import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ISupplierInventoryWarehouseStatusApi } from './base/supplierInventoryWarehouseStatusApi';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';

const baseRoute: string = 'SupplierInventoryWarehouseStatus';

export class SupplierInventoryWarehouseStatusApi extends ISupplierInventoryWarehouseStatusApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}
